export class ValidationResult {
  isValid: boolean;
  /** Reasons for failing invalidation. Do not include punctuation at the end. The Reason property will combine all the reasons. */
  reasons: string[];

  /** Comma separated list of reasons ending with a period. */
  get reason(): string {
    if (this.reasons && this.reasons.length > 0) {
      return `${this.reasons.join(', ')}.`;
    }
    return '';
  }

  /**
   *  Initially set to invalid with list of reasons for invalid.
   */
  constructor() {
    this.isValid = false;
    this.reasons = [];
  }
}